(function() {
  var API = "https://web-production-9d09b.up.railway.app/api/attribution";
  var SESSION_API = "https://web-production-9d09b.up.railway.app/api/sessions";
  var VID_KEY = "lilac_visitor_id";
  var SID_KEY = "lilac_session_id";
  var STORAGE_KEY = "lilac_first_touch";

  // Generate or retrieve persistent visitor ID.
  // Reads from cookie FIRST (survives in-app-browser -> Safari handoff on same device),
  // falls back to localStorage, then mints a new one. Always mirrors to both.
  function readCookie(name) {
    try {
      var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]+)"));
      return m ? decodeURIComponent(m[1]) : null;
    } catch(e) { return null; }
  }
  function writeCookie(name, value, days) {
    try {
      var exp = new Date();
      exp.setDate(exp.getDate() + days);
      document.cookie = name + "=" + encodeURIComponent(value)
        + ";expires=" + exp.toUTCString() + ";path=/;SameSite=Lax";
    } catch(e) {}
  }

  function getOrCreatePersistentId(key) {
    var id = readCookie(key);
    if (!id) {
      try { id = localStorage.getItem(key); } catch(e) {}
    }
    if (!id) {
      id = "v-" + Math.random().toString(36).substr(2, 9) + "-" + Date.now().toString(36);
    }
    try { localStorage.setItem(key, id); } catch(e) {}
    writeCookie(key, id, 365);
    return id;
  }

  function generateUUID() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0;
      return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  function getOrCreateSessionId(key) {
    var id = null;
    try { id = sessionStorage.getItem(key); } catch(e) {}
    if (!id) {
      id = "v-" + Math.random().toString(36).substr(2, 9) + "-" + Date.now().toString(36);
      try { sessionStorage.setItem(key, id); } catch(e) {}
    }
    return id;
  }

  var visitorId = getOrCreatePersistentId(VID_KEY);
  var sessionId = getOrCreateSessionId(SID_KEY);

  // Parse UTM params and fbclid
  var params = new URLSearchParams(window.location.search);
  var utmSource = params.get("utm_source");
  var utmMedium = params.get("utm_medium");
  var utmCampaign = params.get("utm_campaign");
  var utmTerm = params.get("utm_term");
  var utmContent = params.get("utm_content");
  var fbclid = params.get("fbclid");
  var gclid = params.get("gclid");

  // If fbclid present but no UTMs, it's a Facebook/Instagram click (organic or shared link).
  // Paid ads always carry explicit UTMs from the creative url_tags — don't label fbclid-only as paid.
  if (fbclid && !utmSource) {
    utmSource = "facebook";
    utmMedium = "social";
  }
  // If gclid present but no UTMs, infer Google paid
  if (gclid && !utmSource) {
    utmSource = "google";
    utmMedium = "cpc";
  }

  var hasTracking = utmSource || utmMedium || utmCampaign;

  // ── Meta Ad Click Cookie (_lilac_meta) ──────────────────────────────
  // Captures paid Meta click data. Stored in BOTH cookie (30d) and localStorage
  // (permanent). Safari ITP caps JS cookies to 24h when user arrives from Facebook
  // with fbclid, so localStorage is the reliable store for return-visit attribution.
  // Last Meta touch wins; non-Meta visits never clear the data.
  var META_COOKIE = "_lilac_meta";
  var META_LS_KEY = "_lilac_meta";
  var isPaidMeta = utmSource && utmSource.toLowerCase() === "facebook"
    && utmMedium && /^(paid_social|cpc|paid)$/i.test(utmMedium);
  var isFbclidOnly = fbclid && !isPaidMeta && !params.get("utm_source");

  if (isPaidMeta || isFbclidOnly) {
    var metaData = {
      ts: Math.floor(Date.now() / 1000),
      src: (utmSource || "facebook").toLowerCase(),
      med: isPaidMeta ? (utmMedium || "paid_social").toLowerCase() : "fbclid_only",
      cmp: utmCampaign || "",
      cnt: utmContent || "",
      trm: utmTerm || "",
      uid: params.get("utm_id") || "",
      fbc: fbclid || ""
    };
    var metaJson = JSON.stringify(metaData);
    // Store in both cookie and localStorage
    var metaExp = new Date();
    metaExp.setDate(metaExp.getDate() + 30);
    try {
      document.cookie = META_COOKIE + "=" + encodeURIComponent(metaJson)
        + ";expires=" + metaExp.toUTCString() + ";path=/;SameSite=Lax";
    } catch(e) {}
    try { localStorage.setItem(META_LS_KEY, metaJson); } catch(e) {}
  }

  // 1. If landing with UTMs or ad click IDs, fire visit event immediately
  if (hasTracking) {
    var visitData = {
      visitor_id: visitorId,
      session_id: sessionId,
      utm_source: utmSource || "",
      utm_medium: utmMedium || "",
      utm_campaign: utmCampaign || "",
      utm_term: utmTerm || "",
      utm_content: utmContent || "",
      fbclid: fbclid || "",
      landing_page: window.location.pathname,
      referrer: document.referrer || ""
    };

    // Fire and forget
    try {
      fetch(API + "/visit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(visitData)
      }).catch(function() {});
    } catch(e) {}

    // ── Session event for Meta click-quality reconciliation ──────────
    // One POST per fresh UTM arrival per browser session. Uses sendBeacon
    // so the event survives immediate bounces (the cohort where Meta's
    // inflated clicks hide). Idempotent on session_uuid: same UTMs in
    // same session = same UUID = backend dedupes via ON CONFLICT DO NOTHING.
    if (utmSource) {
      var seKey = "lilac_se_" + utmSource + "_" + (utmCampaign || "") + "_" + (utmContent || "");
      var seUUID;
      try { seUUID = sessionStorage.getItem(seKey); } catch(e) {}
      if (!seUUID) {
        seUUID = generateUUID();
        try { sessionStorage.setItem(seKey, seUUID); } catch(e) {}
      }
      var sePayload = JSON.stringify({
        session_uuid: seUUID,
        visitor_id: visitorId,
        utm_source: utmSource,
        utm_medium: utmMedium || "",
        utm_campaign: utmCampaign || "",
        utm_content: utmContent || "",
        utm_term: utmTerm || "",
        fbclid: fbclid || "",
        landing_url: window.location.href,
        referrer: document.referrer || "",
        client_timestamp: new Date().toISOString()
      });
      try {
        if (navigator.sendBeacon) {
          navigator.sendBeacon(SESSION_API, new Blob([sePayload], {type: "application/json"}));
        } else {
          fetch(SESSION_API, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: sePayload,
            keepalive: true
          }).catch(function() {});
        }
      } catch(e) {}
    }

    // Also store in localStorage for checkout linking (backward compat)
    try {
      var existing = localStorage.getItem(STORAGE_KEY);
      if (!existing) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(visitData));
        var exp = new Date(); exp.setDate(exp.getDate() + 90);
        document.cookie = STORAGE_KEY + "=" + encodeURIComponent(JSON.stringify(visitData))
          + ";expires=" + exp.toUTCString() + ";path=/;SameSite=Lax";
      }
    } catch(e) {}
  }

  // 2. Track page views within session (fires on every page after landing)
  var alreadySentVisit = false;
  try { alreadySentVisit = sessionStorage.getItem("lilac_visit_sent"); } catch(e) {}

  if (alreadySentVisit && !hasTracking) {
    // Not the landing page — send pageview to increment counter
    try {
      fetch(API + "/pageview", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          visitor_id: visitorId,
          session_id: sessionId,
          page: window.location.pathname
        })
      }).catch(function() {});
    } catch(e) {}
  }

  if (hasTracking) {
    try { sessionStorage.setItem("lilac_visit_sent", "1"); } catch(e) {}
  }

  // 3. Stamp visitor_id + Meta cookie into cart attributes so they survive checkout
  // Cart note_attributes flow through to the Shopify order — this is how we link visits to orders
  // since the thank-you page doesn't load theme JS.
  var cartAttrs = { _lilac_vid: visitorId, _lilac_sid: sessionId };

  // Read _lilac_meta from cookie first, fall back to localStorage.
  // Safari ITP kills JS cookies after 24h for Meta-referred traffic,
  // but localStorage persists — this is how we detect return-visit purchases.
  var metaRaw = null;
  try {
    var metaMatch = document.cookie.match(new RegExp(META_COOKIE + "=([^;]+)"));
    if (metaMatch) metaRaw = decodeURIComponent(metaMatch[1]);
  } catch(e) {}
  if (!metaRaw) {
    try { metaRaw = localStorage.getItem(META_LS_KEY); } catch(e) {}
  }
  if (metaRaw) {
    try {
      var mc = JSON.parse(metaRaw);
      // Only stamp if click is within 30 days (localStorage has no expiry)
      var metaAge = Math.floor(Date.now() / 1000) - (mc.ts || 0);
      if (metaAge < 30 * 86400) {
        cartAttrs._meta_cmp = mc.cmp || "";
        cartAttrs._meta_cnt = mc.cnt || "";
        cartAttrs._meta_trm = mc.trm || "";
        cartAttrs._meta_ts = String(mc.ts || "");
        cartAttrs._meta_fbc = mc.fbc || "";
        cartAttrs._meta_src = mc.src || "";
        cartAttrs._meta_med = mc.med || "";
      } else {
        // Expired — clean up
        try { localStorage.removeItem(META_LS_KEY); } catch(e) {}
      }
    } catch(e) {}
  }

  // Read Meta's _fbp cookie (browser ID set by the Pixel) and stamp into cart.
  // This flows through to order note_attributes so Shopify's CAPI can include it,
  // improving Event Match Quality from ~50% to 80%+.
  try {
    var fbpMatch = document.cookie.match(/(?:^|; )_fbp=([^;]+)/);
    if (fbpMatch) {
      var fbpValue = fbpMatch[1];
      if (fbpValue) {
        cartAttrs._meta_fbp = fbpValue;
        console.log("_fbp stamped:", fbpValue);
      }
    }
  } catch(e) {
    console.log("_fbp read error:", e);
  }

  try {
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: cartAttrs })
    }).catch(function(e) { console.log("cart update error:", e); });
  } catch(e) {}

  // 4. Review engagement tracking (product pages only)
  if (window.location.pathname.indexOf("/products/") === 0) {
    var productHandle = window.location.pathname.split("/products/")[1].split("?")[0].split("#")[0];
    var reviewDedupKey = "lilac_review_" + sessionId + "_" + productHandle + "_";

    function sendReviewEvent(eventType, productId) {
      var dedupFlag = reviewDedupKey + eventType;
      try { if (sessionStorage.getItem(dedupFlag)) return; } catch(e) {}
      try { sessionStorage.setItem(dedupFlag, "1"); } catch(e) {}
      try {
        fetch(API + "/review-event", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            visitor_id: visitorId,
            session_id: sessionId,
            product_handle: productHandle,
            product_id: productId || "",
            event_type: eventType
          })
        }).catch(function() {});
      } catch(e) {}
    }

    // Fire product_view immediately
    sendReviewEvent("product_view");

    // Poll for Yotpo widget (loads async)
    var yotpoAttempts = 0;
    var yotpoTimer = setInterval(function() {
      yotpoAttempts++;
      var yotpoEl = document.querySelector(".yotpo.bottomLine, .yotpo-main-widget, .yotpo-reviews");
      if (!yotpoEl && yotpoAttempts >= 20) { clearInterval(yotpoTimer); return; }
      if (!yotpoEl) return;
      clearInterval(yotpoTimer);

      // Get product ID from Yotpo data attribute
      var pidEl = document.querySelector("[data-product-id]");
      var productId = pidEl ? pidEl.getAttribute("data-product-id") : "";

      // IntersectionObserver for reviews_visible
      if (window.IntersectionObserver) {
        var visibleFired = false;
        var observer = new IntersectionObserver(function(entries) {
          if (visibleFired) return;
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              visibleFired = true;
              sendReviewEvent("reviews_visible", productId);
              observer.disconnect();
              break;
            }
          }
        }, { threshold: 0.1 });
        observer.observe(yotpoEl);
      }

      // Click listener for reviews_click
      yotpoEl.addEventListener("click", function() {
        sendReviewEvent("reviews_click", productId);
      });
    }, 500);
  }

  // 5. On thank-you page, link visit to order + store first-touch attribution (kept as fallback)
  if (window.Shopify && window.Shopify.checkout && window.Shopify.checkout.order_id) {
    var orderId = window.Shopify.checkout.order_id;

    // Link the visit to this order
    try {
      fetch(API + "/visit/convert", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ visitor_id: visitorId, order_id: orderId })
      }).catch(function() {});
    } catch(e) {}

    // Original first-touch attribution (backward compat)
    var stored = null;
    try { stored = localStorage.getItem(STORAGE_KEY); } catch(e) {}
    if (!stored) {
      try {
        var match = document.cookie.match(new RegExp(STORAGE_KEY + "=([^;]+)"));
        if (match) stored = decodeURIComponent(match[1]);
      } catch(e) {}
    }
    if (stored) {
      try {
        var attr = JSON.parse(stored);
        attr.order_id = orderId;
        fetch(API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(attr)
        }).then(function() {
          try { localStorage.removeItem(STORAGE_KEY); } catch(e) {}
          try {
            document.cookie = STORAGE_KEY + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
          } catch(e) {}
        }).catch(function() {});
      } catch(e) {}
    }
  }
})()
